import http from './http';
import serviceHelper from './serviceHelper';

export const getOverviewStats = async () => {
  return serviceHelper(http.get('/admin/dashboard/overview-stats'), false);
};

export const getUserGrowthGraph = async (filter: number) => {
  return serviceHelper(
    http.get(`/admin/dashboard/user-growth-graph?filter=${filter}`),
    false
  );
};

export const getSchoolEngagementGraph = async (filter: number) => {
  return serviceHelper(
    http.get(`/admin/dashboard/school-engagement-graph?filter=${filter}`),
    false
  );
};

export const getRecentActivities = async () => {
  return serviceHelper(http.get('/admin/dashboard/recent-activities'), false);
};
